/**
 * Utility functions for calendar link management
 */

/**
 * Gets the user's timezone using the browser's Intl API
 * @returns The user's timezone (e.g., "Asia/Kolkata", "America/New_York")
 */
export function getUserTimezone(): string {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
	} catch (error) {
		console.warn('Failed to get user timezone:', error);
		// Fallback to UTC if timezone detection fails
		return 'UTC';
	}
}

/**
 * Adds timezone parameter to a cal.com URL
 * @param calUrl - The original cal.com URL
 * @param timezone - The timezone to add (defaults to user's detected timezone)
 * @returns The URL with timezone parameter added
 */
export function addTimezoneToCalUrl(calUrl: string, timezone?: string): string {
	try {
		const url = new URL(calUrl);
		const tz = timezone || getUserTimezone();

		// Add or update the cal.tz parameter
		url.searchParams.set('cal.tz', tz);

		return url.toString();
	} catch (error) {
		console.warn('Failed to add timezone to cal.com URL:', error);
		// Return original URL if processing fails
		return calUrl;
	}
}
